import React from "react";

const FestivalShimmerCard = () => {
  return (
    <div className="tw-bg-white tw-rounded-lg tw-overflow-hidden tw-shadow-md tw-h-full tw-flex tw-flex-col">
      <div className="tw-h-48 tw-bg-gray-200 tw-animate-pulse"></div>
      <div className="tw-p-4 tw-flex tw-flex-col tw-flex-grow">
        <div className="tw-h-6 tw-bg-gray-200 tw-rounded tw-animate-pulse tw-w-3/4 tw-mb-4"></div>
        <div className="tw-flex tw-flex-col tw-gap-2 tw-flex-grow">
          <div className="tw-h-4 tw-bg-gray-200 tw-rounded tw-animate-pulse tw-w-full"></div>
          <div className="tw-h-4 tw-bg-gray-200 tw-rounded tw-animate-pulse tw-w-full"></div>
          <div className="tw-h-4 tw-bg-gray-200 tw-rounded tw-animate-pulse tw-w-3/4"></div>
        </div>
      </div>
    </div>
  );
};

export default FestivalShimmerCard;
